module.exports = __webpack_public_path__ + "static/img/05.adc4a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/05.png
// module id = NsxL
// module chunks = 0